/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Dispatch } from 'redux';
import { getAllPasswordPolicy, getPasswordPolicyRule } from '../../services/setting';
import {
  getPasswordPoliciesStart,
  getPasswordPoliciesSuccess,
  getPasswordPoliciesFailure,
  getPasswordPolicyDetailsStart,
  getPasswordPolicyDetailsSuccess,
  getPasswordPolicyDetailsFailure,
  getPasswordPoliciesRuleStart,
  getPasswordPoliciesRuleSuccess,
  getPasswordPoliciesRuleFailure
} from './passwordPoliciesActionCreator';

export const fetchPasswordPolicies = async (dispatch: Dispatch) => {
  dispatch(getPasswordPoliciesStart());
  try {
    const passwordPolicies = await getAllPasswordPolicy();
    dispatch(getPasswordPoliciesSuccess(passwordPolicies));
  } catch (error: any) {
    dispatch(getPasswordPoliciesFailure(`Error in fetching password policies: ${error}`));
  }
};

export const fetchPasswordPolicyDetails = async (dispatch: Function, passwordPolicyId: string) => {
  dispatch(getPasswordPolicyDetailsStart(passwordPolicyId));
  try {
    const policyDetails = await getPasswordPolicyRule(passwordPolicyId);
    dispatch(getPasswordPolicyDetailsSuccess(passwordPolicyId, policyDetails));
  } catch (error: any) {
    dispatch(getPasswordPolicyDetailsFailure(passwordPolicyId, `Error in fetching password policy details: ${error}`));
  }
};

export const fetchPasswordPoliciesRule = async (dispatch: Dispatch, policyId: string) => {
  dispatch(getPasswordPoliciesRuleStart());
  try {
    const passwordPolicies = await getPasswordPolicyRule(policyId);
    dispatch(getPasswordPoliciesRuleSuccess(passwordPolicies));
  } catch (error: any) {
    dispatch(getPasswordPoliciesRuleFailure(`Error in fetching password policy rule: ${error}`));
  }
}